<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    SKU Sales Report
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Date
                        Range
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-select
                    :items="cities"
                    label="Select City"
                    dense
                    class="ml-2 mt-2"
                    v-model="currentCity"
                  ></v-select>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Sales per SKU Type
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.types.headers"
            :items="table.types.data"
            :items-per-page="10"
            :loading="table.types.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.types.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Sales per SKU No. of Devices
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.devices.headers"
            :items="table.devices.data"
            :items-per-page="10"
            :loading="table.devices.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.devices.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  mixins: [ShareableMethods],
  data() {
    return {
      currentCity: "All",
      cities: ["All"],
      dates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
      ],
      menu: false,
      modal: false,

      search: "",
      table: {
        types: {
          loading: false,
          headers: [
            {
              text: "Date",
              sortable: false,
              value: "date",
              // formatter: (x) => (x ? moment(x).format("DD-MMM") : null),
            },
            {
              text: "7-days SKU",
              sortable: false,
              value: "day7",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "15-days SKU",
              sortable: false,
              value: "day15",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "30-days SKU",
              sortable: false,
              value: "day30",
              formatter: (x) => this.setToLocaleString(x),
            },
          ],
          data: [],
        },

        devices: {
          loading: false,
          headers: [
            {
              text: "Date",
              sortable: false,
              value: "date",
            },
            {
              text: "4G",
              sortable: false,
              value: "device4",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "5G",
              sortable: false,
              value: "device5",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "6G",
              sortable: false,
              value: "device6",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "7G",
              sortable: false,
              value: "device7",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "8G",
              sortable: false,
              value: "device8",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "9G",
              sortable: false,
              value: "device9",
              formatter: (x) => this.setToLocaleString(x),
            },
          ],
          data: [],
        },
      },
    };
  },

  methods: {
    async getList() {
      this.table.devices.loading = true;
      this.table.types.loading = true;
      await this.$api
        .get(
          `/acquisition/report?report=skuSales&startDate=${
            this.dates[0]
          }&endDate=${this.dates[1]}&city=${
            this.currentCity == "All" ? "" : this.currentCity
          }`
        )
        .then((response) => {
          const newArr = response.data.data;
          this.table.types.data = newArr.skuTypes;
          newArr.cities.forEach((city) => {
            this.cities.push(city);
          });
          this.table.types.loading = false;

          this.table.devices.data = newArr.skuDevices;
          this.table.devices.loading = false;
        })
        .catch((e) => {
          this.table.types.loading = false;
          this.table.devices.loading = false;
          console.log(e);
        });
    },
    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates() {
      this.getList();
    },

    currentCity() {
      this.getList();
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
<style scope>
.month-label {
  font-size: 0.9rem;
  color: #9e9e9e;
}
</style>
